import { OrgCfgSchemaTypes } from "@bfc-software/api-schemas";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOnly,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

type Paths = OrgCfgSchemaTypes.paths;

/**
 * org_config.yaml declares this service's auth as `X-CLIENT-CODE` (apiKey),
 * not the `Authorization: Bearer` scheme every other service client in this
 * app uses -- the config service does not read an Authorization header at
 * all, so the AAA session JWT goes in X-CLIENT-CODE instead.
 */
const spec = () => ({
  baseUrl: `${getEnv().orgCfgServiceBase}/orgs/config/v1`,
  select: aaaTokenOnly,
  authHeaders: (t: string) => ({ "X-CLIENT-CODE": t }),
});

export const useOrgCfgApi = () => useAuthenticatedApi<Paths>(spec());

/** Raw fetch client for callers that need the response status itself (a 404 here means "no settings saved yet", not a failure). */
export const useOrgCfgFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());

export type OrgCfgFetchClient = ReturnType<typeof useOrgCfgFetchClient>;
